import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=a466226c&scoped=true&"
import script from "./OrgList.vue?vue&type=script&lang=js&"
export * from "./OrgList.vue?vue&type=script&lang=js&"
import style0 from "./OrgList.vue?vue&type=style&index=0&id=a466226c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a466226c",
  null
  
)

export default component.exports